import { CheckInStatus } from '../models/CheckInStatus.model';

/**
 * A participant's check-in can complete in two ways: through our own check-in flow
 * (`isCompleted`), or outside it (`isCompletedExternally`) - for example when a borrower
 * completes pre-signing in ESign and is handed off to the notary session.
 *
 * Readiness checks must accept both. Gating on `isCompleted` alone leaves externally
 * completed participants permanently "not ready", which stalls the waiting room.
 */
export const isCheckInComplete = (checkInStatus: CheckInStatus | undefined | null): boolean =>
  checkInStatus?.isCompleted === true || checkInStatus?.isCompletedExternally === true;
